export function getLogoUrl(logoName, currentLocation) {
  if (currentLocation.indexOf('-dev') !== -1 || currentLocation.indexOf('localhost') !== -1) {
    return 'https://global-assets-dev.fitch.group/images/' + logoName;
  } else if (currentLocation.indexOf('-qa') !== -1) {
    return 'https://global-assets-qa.fitch.group/images/' + logoName;
  } else if (currentLocation.indexOf('-stg') !== -1) {
    return 'https://global-assets-stg.fitch.group/images/' + logoName;
  } else {
    return 'https://global-assets.fitch.group/images/' + logoName;
  }
}
